<!-- 后台人员管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text">后台人员管理</div>
        <el-button @click="addShopBut" round type="primary" size="small"
          >新增管理员</el-button
        >
      </div>   
      <div class="content ">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="AdminList.list"
          style="width: 100%"
        >
          <el-table-column prop="adId" label="#" width="110"> </el-table-column>
          <!-- <el-table-column prop="adUname" label="账号"> </el-table-column>
          <el-table-column prop="adName" label="管理者"> </el-table-column> -->
          <el-table-column prop="adName" label="账号"> </el-table-column>
          <el-table-column prop="adUname" label="管理者"> </el-table-column>
          <el-table-column prop="adRole" label="角色类型">
            <template slot-scope="scope">
              {{ scope.row.adRole | filterRole }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.adActivate | filterNum('停用', '激活') }}
            </template>
          </el-table-column>
          <el-table-column prop="adRegister" label="登录时间" width="230">
          </el-table-column>
          <el-table-column label="编辑">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                v-if="scope.row.adId != myAdId"
                >修改</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="delBut(scope.row)"
                v-if="scope.row.adId != myAdId"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ AdminList.total }}条记录，</span>
            <span class="pageNum">{{ AdminList.pageNum }}</span>
            <span>/{{ AdminList.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="AdminList.pageNum"
            :page-size="AdminList.pageSize"
            layout="prev, pager, next, jumper"
            :total="AdminList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增与编辑 -->
    <div class="dialog">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogAdmin"
        width="30%"
        :dialogAdminClose="true"
        :before-close="dialogAdminClose"
      >
        <span slot="title">
          <span class="header-main-title">{{ dialogTitle }}</span>
        </span>
        <div class="adminForm textalignLeft">
          <el-form ref="adminForm" :model="adminForm" label-width="80px">
            <el-form-item label="手机号">
              <el-input v-model="adminForm.tel" :disabled="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input v-model="adminForm.name"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" v-if="!isEdit">
              <el-input v-model="adminForm.Password"></el-input>
            </el-form-item>
            <el-form-item label="角色类型">
              <el-select v-model="adminForm.adRole" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input v-model="adminForm.Email"></el-input>
            </el-form-item>
            <el-form-item label="可用状态">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="adminForm.activate"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdmin = false">取 消</el-button>
          <el-button type="primary" @click="dialogAdminBut">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiGetAdminList,
  apiAddAdmin,
  apiDelAdmin,
  apiEditAdmin
} from '@/api/ControlPane'

export default {
  name: '',
  props: [''],
  data() {
    return {
      AdminListlist:[],
      AdminList: [],
      page: '1', // 页数
      dialogAdmin: false,
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      myAdId: '',
      adminForm: {
        name: '',
        tel: '',
        Password: '',
        adRole: 0,
        Email: '',
        activate: 0 // 是否可用
      },
      options: [{label: '管理员', value: 0}, {label: '健康管家', value: 1}],
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetAdminList()
    this.myAdId = localStorage.getItem('myAdId');
  },

  methods: {
    // 新增管理员
    addShopBut() {
      this.dialogTitle = '新增管理员'
      this.dialogAdmin = true
      // this.$router.push({
      //   path: '/addShop'
      // })
    },
    // 列表删除
    delBut(row) {
      console.log(row)
      apiDelAdmin({
        adId: row.adId
      }).then(res => {
        if (res.status === 0) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.GetAdminList()
        }
      })
    },
    // 列表修改
    editBut(row) {
      this.dialogTitle = '修改管理员'
      console.log(row)
      this.isEdit = true
      this.adId = row.adId
      this.adminForm.tel = row.adName
      this.adminForm.name = row.adUname
      this.adminForm.adRole= row.adRole
      this.adminForm.Email = row.adEmail
      this.adminForm.activate = row.adActivate
      this.dialogAdmin = true
    },
    // 弹窗：新增/修改管理员确定
    dialogAdminBut() {
      if (this.isEdit === false) {
        if (!this.objNaN(this.adminForm, this.adminFormList)) {
          apiAddAdmin({
            adName: this.adminForm.tel,
            adUname: this.adminForm.name,
            adEmail: this.adminForm.Email,
            adRole: this.adminForm.adRole,
            adActivate: this.adminForm.activate,
            adPassword: this.adminForm.Password
          }).then(res => {
            if (res.status === 0) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.adminForm = {
                name: '',
                tel: '',
                Password: '',
                adRole: 0,
                Email: '',
                activate: 0
              }
              this.dialogAdmin = false
              this.GetAdminList()
            }
          })
        }
      } else {
        switch (true) {
          case !this.adminForm.name:
            this.$message.error('名字不能为空！')
            break
          case !this.adminForm.tel:
            this.$message.error('手机号不能为空！')
            break
          default:
            apiEditAdmin({
              adId: this.adId,
              adName: this.adminForm.tel,
              adUname: this.adminForm.name,
              adRole: this.adminForm.adRole,
              adEmail: this.adminForm.Email,
              adActivate: this.adminForm.activate
            }).then(res => {
              if (res.status === 0) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.isEdit = false
                this.dialogAdmin = false
                this.adminForm = {
                  name: '',
                  tel: '',
                  Password: '',
                  adRole: 0,
                  Email: '',
                  activate: 0
                }
                this.GetAdminList()
              }
            })
        }
      }
    },

    // 弹窗关闭回调
    dialogAdminClose(e) {
      console.log(e)

      this.dialogAdmin = false
      this.isEdit = false
      this.adminForm = {
        name: '',
        tel: '',
        Password: '',
        adRole: 0,
        Email: '',
        activate: 0 // 是否可用
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val
      console.log(`当前页: ${val}`)
      this.GetAdminList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 获取管理人员列表
    GetAdminList() {
      apiGetAdminList({
        page: this.page,
        pageSize: 20
      }).then(res => {
        if (res.status === 0) {
          this.AdminList = res.data
          //张  改
          this.AdminList.list.sort(function(a,b){
              return a.adId - b.adId
                // 　　if(a.adId === b.adId){//如果id相同，按照age的降序
                // 　　　　return b.age - a.age
                // 　　}else{
                // 　　　　return a.id - b.id
                // 　　}
          })
          console.log(this.AdminList.list)
        }
      })
    },
     

  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 52px;
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    height: calc(100vh - 172px);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-table {
      height: calc(100vh - 224px);
      overflow: auto;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
